// src/components/ui/FormSkeleton.jsx
import React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';

export default function FormSkeleton({ fields = 5 }) {
  return (
    <Box>
      {/* Skeleton for Title and Description */}
      <Skeleton variant="text" width="40%" height={40} />
      <Skeleton variant="text" width="70%" height={24} sx={{ mb: 4 }} />

      {/* Skeletons for Form Fields */}
      <Stack spacing={4}>
        {Array.from({ length: fields }).map((_, i) => (
          <Box key={i}>
            <Skeleton variant="text" width="25%" height={20} sx={{ mb: 1 }} />
            <Skeleton variant="rectangular" width="100%" height={56} sx={{ borderRadius: 1 }}/>
          </Box>
        ))}
      </Stack>

      {/* Skeleton for Submit Button */}
      <Skeleton variant="rectangular" width={100} height={40} sx={{ mt: 4, borderRadius: 1 }} />
    </Box>
  );
}